import React, { useState } from 'react'
import './App.css'
import LayoutAuth from './components/layout-auth'
import LayoutPublic from './components/layout-public'
import DarkMode from './components/dark-mode'
import { UserProvider, useUserContext, AppCheckWrapper,
  MuniProvider, MuniCheckWrapper , SnackbarProvider
} from 'strview-common'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'



const Layout = () => {
  const userContext = useUserContext()
  const [mode, setMode] = useState('dark')
  const queryClient = new QueryClient()
  const appName = process.env.REACT_APP_APP_NAME

  return (
    <QueryClientProvider client={queryClient}>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DarkMode mode={mode} setMode={setMode}>
          <MuniProvider>
            {userContext.user === null || userContext.user.loggedIn === false ? (
              <SnackbarProvider>
              <LayoutPublic />
              </SnackbarProvider>
            ) : (
              <AppCheckWrapper appName={appName} displayMessage={true} enforceApp={false}>
                <MuniCheckWrapper userContext={userContext} displayMessage={true} enforceMuni={false}>
                  <SnackbarProvider>
                  <LayoutAuth mode={mode} setMode={setMode} />
                  </SnackbarProvider>
                </MuniCheckWrapper>
              </AppCheckWrapper>
            )}
          </MuniProvider>
        </DarkMode>
      </LocalizationProvider>
    </QueryClientProvider>
  )
}

const App = () => {
  return (
    <UserProvider>
      
        <Layout />
      
    </UserProvider>
  )
}

export default App
